var shortCutImg = 'https://statich5clover.happyelements.com/resource/share/bg/bg_1.jpg';
const SnsMini = require("./SnsMini");

let sns = xClass("snsbaiduGame", SnsMini)

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    this._adDcName = 'baidu_video_ad';
    mini.appSid = 'fab38ed9';
    this.antiAddictionTime = 0;
    this.antiAddictionHasEnterGame = false;
    this.antiAddictionDialog = null;
}

sns.prototype._packShareParam = function () {
    let param = {
        onShare: ()=> { 
            let textConfig = TextsManager.getInstance().getRandomTexts('default')
            console.warn("[####]textconfig:"+JSON.stringify(textConfig))
            let shareInfo = {
                title: textConfig.content,
                imageUrl: textConfig.bg,
                query: this.getShareLinkStr({
                    textId: textConfig.textId
                })
            }
            return shareInfo
        }
    }
    return param;   
}

sns.prototype.showAntiAddictionDialog = function(content, callback){
    if (this.antiAddictionDialog){
        this.antiAddictionDialog.removeFromeParent();
        this.antiAddictionDialog = null;
    }

    var dialogRes = [
        "cocos/uilibrary.plist"
    ]
    var showDialog = function(){
        this.antiAddictionDialog = dialog.create({
            text: content,
            needOkBtn: true,
            okBtnText: "确定",
            cleanupCb: callback
        }, callback)
        this.antiAddictionDialog.popup();
        this.antiAddictionDialog.getParent().getParent().setLocalZOrder(10000)
    }
    let dialog = require("clover/panel/AlertDialog");
    if (dialog.isReady()) {
        showDialog()
    }else{
        function resOnSuccess() {
            showDialog();
        }
        function resOnFail() {
            Toast.make(content, null, callback);
        }
        preloadWithLoading(dialogRes, resOnSuccess, resOnFail, resOnFail);
    }
}

sns.prototype.antiAddictionCb = function(res){
    console.warn("!!!!antiAddictionCb!!!! antiAddictionTime", this.antiAddictionTime, "antiAddictionHasEnterGame", this.antiAddictionHasEnterGame);
    if (res && (res.state == 10001 || res.state == 10002 || res.state == 10003)){
        // 10001 需要限制游戏（非法定节假日游戏时间限制1.5小时）
        // 10002 需要限制游戏（法定节假日游戏时间限制3小时）
        var content = null;
        if (res.state == 10001){
            content = getText("baidu.adntiAddiction.msg1");
        }else if (res.state == 10002){
            content = getText("baidu.adntiAddiction.msg2");
        }else if (res.state == 10003){
            // 未成年的提示是要直接关闭的，打点不同
            content = getText("baidu.adntiAddiction.msg4");
        }
        var callback = function(){
            cc.log("防沉迷第一次提示");
        }
        var successCb = function(){
            console.warn("success");
        }
        var failCb = function(){
            console.warn("fail");
        }
        var completeCb = function(){
            console.warn("complete");
        }
        if (this.antiAddictionTime == 0 && res.state != 10003){
            // 第一次提示可以关闭
            var waitTime = 5*60*1000;
            this.antiAddictionTime = Localhost.timeInSec();
            setTimeout(()=>{
                // 第一次提示5分钟后自动出第二次强制关闭
                content = getText("baidu.adntiAddiction.msg3");
                var callback2 = function(){
                    mini.exitMiniProgram({
                        success:successCb,
                        fail:failCb,
                        complete:completeCb
                    });
                }
                this.showAntiAddictionDialog(content, callback2);
                DCAssist.userTrack("real_name", "show", {type:3});
            }, waitTime);
            // if (cc.Director.getInstance().getRunningScene().name == "GameScene"){
                this.needShowAnitiAddictionState = res.state;
            // }
            DCAssist.userTrack("real_name", "show", {type:1});
            this.showAntiAddictionDialog(content, callback);
        }else if(this.antiAddictionHasEnterGame || res.state == 10003){
            // 结束游戏关卡后直接出
            if (res.state != 10003){
                content = getText("baidu.adntiAddiction.msg3");
            }
            callback = function(){
                mini.exitMiniProgram({
                    success:successCb,
                    fail:failCb,
                    complete:completeCb
                });
            }
            this.showAntiAddictionDialog(content, callback);
            if (res.state == 10003){
                DCAssist.userTrack("real_name", "show", {type:4});
            }else{
                DCAssist.userTrack("real_name", "show", {type:2});
            }
            this.showAntiAddictionDialog(content, callback);
        }
    }
}

// 结束游戏关卡时需要提示的防沉迷
sns.prototype.getAnitiAddictionState = function(){
    return this.needShowAnitiAddictionState;
}

sns.prototype.setAntiAddictionHasEnterGame = function(){
    this.antiAddictionHasEnterGame = true;
}

sns.prototype.getAntiAddictionHasEnterGame = function(){
    return this.antiAddictionHasEnterGame
}

/**
 * 转译广告位
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    return '6290374';
}

sns.prototype.isFromShortcut = function (sceneValues) {
    let launchOptions = mini.getLaunchOptionsSync()
    let scene = launchOptions? launchOptions.scene: 0;
    if (!scene)
        return false;
        
    if (!sceneValues)
        sceneValues = mini.getShortcutSceneValues();
    if (!sceneValues || sceneValues.length == 0)
        return false;

    let sceneStr = scene.toString();
    // 百度场景值判断前缀，文档里没有写
    for(let i = 0, l = sceneValues.length; i < l; i++) {
        if (sceneStr.startsWith(sceneValues[i]))
            return true;
    }
    return false;
}
sns.prototype.getOpenKey = function (cb,sessionCb) {
    var self = this

    function sendLog(log) {
        let systemInfo = mini.getSystemInfoSync()
        log += " sdkVersion: " + systemInfo.SDKVersion + ", baiduVersion: " + systemInfo.version + ", systemInfo: " + JSON.stringify(systemInfo)
        if (window.logCenter) {
            let msg = {
                message: "login fail: " + log
            }
            window.logCenter.log(msg)
        } else {
            cc.error("login fail: " + log)
        }
    }

    function showLoginFailModal(reason, log) {
        reason = reason || '登录失败请退出重试'
        sendLog(log)
        mini.showModal({
            title: reason,
            showCancel: false,
            complete: function (res) {
                mini.exitMiniProgram({});
            }
        })
    }

    // /**
    //  * 通过用户信息按键获取用户信息
    //  * @param {(errMsg?: string)-> void} onComplete 
    //  */
    // function getUserInfoByBtn(onComplete) {
    //     if (self.cachedUserInfo) {
    //         onComplete();
    //         return;
    //     }
         
    //     if (self.userInfoBtn) {
    //         onComplete("userInfoBtn is already in stage");
    //         return;
    //     }
    //     console.log("[####]create user info btn")
    //     global.hideProgressbar = true
    //     let fs = cc.director.getOpenGLView().getFrameSize()
    //     let scale = cc.view.getDevicePixelRatio() * fs.width / cc.winSize.width
    //     let btnWidth = 120 * scale
    //     let btnHeight = 72 * scale
    //     let btnX = (fs.width - btnWidth) / 2
    //     let btnY = ((cc.winSize.height - 300) / cc.winSize.height) * fs.height
    //     if (!self.sendDc36) {
    //         dc4UserLoad(36)
    //         self.sendDc36 = true
    //     }
    //     self.userInfoBtn = mini.createUserInfoButton({
    //         type: 'image',
    //         image: 'https://statich5clover.happyelements.com/resource/upload/start_game.png',
    //         withCredentials:true,
    //         style: {
    //             left: btnX,
    //             top: btnY,
    //             width: btnWidth,
    //             height: btnHeight
    //         }
    //     })
        
    //     function onTap(data) {
    //         if (!self.userInfoBtn)
    //             return;
                
    //         if (typeof self.userInfoBtn.offTap === "function")
    //             self.userInfoBtn.offTap(onTap);
            
    //         if (typeof self.userInfoBtn.hide === "function")
    //             self.userInfoBtn.hide();
                
    //         self.userInfoBtn.destroy();
    //         self.userInfoBtn = null;

    //         global.hideProgressbar = null;
    //         if (!self.sendDc41) {
    //             dc4UserLoad(41)
    //             self.sendDc41 = true
    //         }
    //         console.log("[####]on tap sig:"+JSON.stringify(data))
    //         let userInfo = data.userInfo || data.userinfo
    //         if(userInfo) {
    //             self.cachedUserInfo = {
    //                 avatarUrl: userInfo.avatarUrl|| userInfo.headimgurl || "https://ff.happyelements.com/xclover/clover-web@100.png",
    //                 nickName: userInfo.nickName|| userInfo.nickname,
    //                 swanid: data.swanid,
    //                 swanidOld: data.swanid_old,
    //             }
    //             onComplete();
    //         }  else {
    //             onComplete("ontap fail: |no field userinfo");
    //         }
    //     }
    //     self.userInfoBtn.onTap(onTap);
    // }

    // /**
    //  * 11.26开始百度无法使用getUserInfo，必须使用UserInfoBtn获取信息
    //  * 并且对11.26以后版本抱有幻想继续可以使用此接口，所以不用版本号判断，先直接调用getUserInfo，不行再创建按键
    //  * @param {(errMsg?: string)-> void} onComplete 
    //  */
    // function getUserInfo(onComplete) {
    //     if (self.cachedUserInfo) {
    //         onComplete();
    //         return;
    //     }

    //     mini.getUserInfo({
    //         success: function(res) {
    //             console.log("[####]on getUserInfo success:"+JSON.stringify(res))
    //             let userInfo = res.userInfo
    //             self.cachedUserInfo = {
    //                 avatarUrl: userInfo && userInfo.avatarUrl || "https://ff.happyelements.com/xclover/clover-web@100.png",
    //                 nickName: userInfo && (userInfo.nickName|| userInfo.nickname) || "",
    //                 swanid: res.swanid,
    //                 swanid_old: res.swanid_old
    //             }
    //             onComplete();
    //         },
    //         fail: function(res){
    //             console.log("[####]on getUserInfo fail:"+JSON.stringify(res));
    //             // 百度平台11.26以上可能无法调用getUserInfo，必须通过UserInfoBtn获取用户信息
    //             getUserInfoByBtn(onComplete)
    //         }
    //     })
    // }

    // 百度没办法在登陆时候就获取用户名和头像，永远传空
    function onLoginSuccess(swanId, code) {
        console.log("[####]login with code and nickname");
        cb({
            avatarUrl: "",
            nickName: "",
            swanid: swanId,
            swanidOld: swanId,
            code: code
        })
    }

    // 游客登陆
    function mockLogin(swanId) {
        cb({
            avatarUrl: "",
            nickName: "",
            swanid: swanId,
        });
    }

    // 端登录用户登录
    function baiduLogin(swanId) {
        mini.login({
            success: function (res) {
                console.log("[####]baidu login success:"+JSON.stringify(res))
                if (res.code){
                    onLoginSuccess(swanId, res.code)
                } else {
                    mockLogin(swanId)
                }
            },
            fail: function () {
                console.log("[####]baidu login failed use swanid login")
                mockLogin(swanId)
            }
        })
    }

    // 获取一下用户的设备信息
    mini.mockLogin({
        success: function (res){
            if (!res || !res.data || !res.data.swanid) {
                showLoginFailModal(null, "fail to get swanid while mockLogin."+JSON.stringify(res));
            } else {
                let isLogin = mini.isPlatformLogin();
                if (!isLogin) {
                    mockLogin(res.data.swanid);
                } else {
                    baiduLogin(res.data.swanid);
                }
            }
        },
        fail: function (res){
            showLoginFailModal(null, "mockLogin failed."+JSON.stringify(res));
        }
    });
}

sns.prototype.onLoginFinish = function(openid, sessionid){
    console.log("[####]baidu login finish openid:"+openid+" sess:"+sessionid)
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]baidu login finish failed no openid or sessionid")
    }

}
sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    mini.hideKeyboard()
}

sns.prototype.getShareLinkStr = function (data) {
    data = data ? data : {}
    data['inviteCode'] = UserManager.getInstance().getUserRef().uid

    var query = ''
    for (var i in data) {
        query += i + "=" + HeDisplayUtil.urlEncode(data[i]) + "&"
    }

    return query.substr(0, query.length - 1)
}

sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback) {
    imageUrl = imageUrl ? imageUrl : shortCutImg
    title = title ? title : "海滨消消乐"
    //分享链接加上textId
    if (textId && _link) {
        _link = _link + '&textId=' + textId;
    }
    let share = {
        shareInfo: {
            title: title,
            imageUrl: imageUrl,
            query: _link,
            success: ()=> {
                callback({
                    retCode: 0,
                    data: {
                        retCode: 2,
                        msg: "分享成功！"
                    }
                })
            },
            fail: (err, cancel)=> {
                callback({
                    retCode: cancel? 1: 0,
                    data: {
                        retCode: err.errCode,
                        msg: err.errMsg
                    }
                })
            }
        }
    }
    
    console.log("[####]share address:"+JSON.stringify(share.shareInfo))
    mini.shareAppMessage(share.shareInfo)
}

sns.prototype.popBack = function () {
    mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })
}

sns.prototype.drawDataToImg = function (bgpath, info, callback) {

}

sns.prototype.showGridAd = function(config){
    console.warn("not support grid ad");
}

module.exports = sns